import store from '@/store';
import config from '@/config';

/*eslint-disable */
export default {
	install(Vue) {
		if (!config.log && process.env.NODE_ENV === 'development') {
			return;
		}

		Vue.config.errorHandler = (error, vm, message) => {
			let info = {
				type: 'script',
				error: error.message,
				stack: error.stack,
				message
			};
			
			Vue.nextTick(() => {
				store.dispatch('addErrorLog', info);
			});
		};
	}
};
